// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"ddb0017d","298":"e97c886d","453":"78f6332e","888":"12322fd6"}[chunkId] + ".chunk.js";
};